import { ref } from 'vue';
import type { RaumplanungAttributeMetadataListEntry } from 'atlas-shared';
import type { IndicatorFilter } from './IndicatorFilter';
import { useFavoriteAttributes } from '@/composables/useFavoriteAttributes';

/**
 * Filter that keeps only bookmarked (favorite) datasets.
 *
 * The set of favorites is shared via {@link useFavoriteAttributes}; this filter
 * only toggles whether the favorite restriction is active and delegates the
 * membership check to the shared `favorites` list.
 */
export class IsFavoriteFilter implements IndicatorFilter<boolean> {

    readonly id = "isFavorite"

    readonly label = "Favoriten"

    /** Whether the favorite restriction is active. */
    active = ref(false)

    private favorites: ReturnType<typeof useFavoriteAttributes>["favorites"]

    constructor() {
        this.favorites = useFavoriteAttributes().favorites
    }

    applies(dataset: RaumplanungAttributeMetadataListEntry): boolean {
        if (!this.active.value) return true
        return this.favorites.value.includes(dataset.id)
    }

    reset(): void {
        this.active.value = false
    }

    setConfig(config: boolean): void {
        this.active.value = config
    }
}